import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from 'helpers/configuration';

export const msalInstance = new PublicClientApplication(msalConfig);
